export default function tableConfig() {
    // Find all tables on the page
    const tables = document.querySelectorAll('table');

    // Loop through each table
    tables.forEach(table => {
        // Create a wrapping div element
        const wrapper = document.createElement('div');

        wrapper.classList.add('table-wrap');
        wrapper.tabIndex = 0;

        // Append the wrapping div before the table
        table.parentNode.insertBefore(wrapper, table);

        // Move the table into the wrapping div
        wrapper.appendChild(table);
    });
}
